import { useState } from 'react';
import ContactForm from './ContactForm';

const CollapsibleContactForm = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full max-w-2xl mt-8">
      {/* Header / collapsed view */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full bg-accent bg-opacity-30 rounded-xl p-4 text-white font-bold text-lg shadow-lg flex justify-between items-center transition-all duration-300"
      >
        Få Et Uforpligtende Tilbud
        <span className="transform transition-transform duration-300" style={{ rotate: isOpen ? '180deg' : '0deg' }}>
          ▼
        </span>
      </button>

      {/* Expandable form */}
      <div
        className={`overflow-hidden transition-all duration-500 ${isOpen ? 'max-h-[1000px] mt-4' : 'max-h-0'}`}
      >
        <ContactForm />
      </div>
    </div>
  );
};

export default CollapsibleContactForm;
